import { render } from "./HeaderPage.vue?vue&type=template&id=c4d927aa&scoped=true"
import script from "./HeaderPage.js?vue&type=script&lang=js"
export * from "./HeaderPage.js?vue&type=script&lang=js"

import "./HeaderPage.css?vue&type=style&index=0&id=c4d927aa&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d927aa"]])

export default __exports__